<template>
    <div>
        <side-menu />
        <loading-screen v-if="loadingScreen" />
        <section class="container profile-container">
            <div class="profile">
                <h1>Dashboard</h1>
                <div class="card">
                    <div class="card-header">

                    </div>
                    <div class="card-body">

                    </div>
                    <div class="card-footer">

                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>

    export default {
        components: { },
        data() {
            return {
                loading: false,
                loadingScreen: false,
                form: {},
            }
        },
        methods: {
            async getUserData() {
                this.loadingScreen = true;
                try {

                } catch(error) {

                } finally {
                    this.loadingScreen = false;
                }
            },
            async handleSubmit(event) {
                event.preventDefault();
                this.loading = true;
                try{

                } catch(error) {

                } finally {
                    this.loading = false;
                }
            },
        },
        mounted() {
            this.getUserData()
        }
    }
</script>

<style>
  @import "./dashboard.scss";

  @import "../Profile/responsive.css";
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Dashboard.vue